import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FuncionesService } from '../../comun/services/funciones.service';
import { QueryService } from '../../comun/services/query.service';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsuarioPerfil } from '../../comun/models/misdatos.model';
import { MisdatosService } from '../../comun/services/misdatos.service';
// Validaciones error
import { Observable } from 'rxjs';
import { PerfilStatusService } from '../../comun/services/perfil-status.service';
import { PerfilError } from '../../comun/models/perfil-error.model';
import { take } from 'rxjs/operators';
//import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-perfil-publico',
  templateUrl: './perfil-publico.component.html',
  styleUrl: './perfil-publico.component.css'
})
export class PerfilPublicoComponent implements OnInit, OnChanges {
  @Input() userid: number = 0;
  private misdatosSub!: Subscription;
  misdatos: any = {};
  
  public errores$!: Observable<PerfilError[]>;

  constructor(private misdatosService: MisdatosService,
              public funciones: FuncionesService,
              private query: QueryService,
              private statusService: PerfilStatusService,
              /*private toastr: ToastrService*/) {}

  ngOnInit() {
    this.getMisDatos();
  }

  ngOnChanges(changes: SimpleChanges): void {
    /*if (changes['misdatos'] && this.misdatos?.ID) {
      this.getPerfil();
    }*/
  }

  getMisDatos() {
    // Escuchamos el observable misdatos$
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is UsuarioPerfil => misdatos !== null)
      )
      .subscribe((misdatos: UsuarioPerfil) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
        // Nos enlazamos reactivamente al BehaviorSubject a través del Observable
        this.errores$ = this.statusService.errores$;
        // MOMENTO INICIAL: Hacemos la primera carga al arrancar el Web Element
        this.statusService.cargarErroresDesdeBackend();
      });
  }

  public soloConKey(errores: PerfilError[]): PerfilError[] {
    const conkey = errores.filter(e => !!e.error_key && e.error_key.trim() !== '');
    return conkey;
  }  
  public soloSinKey(errores: PerfilError[]): PerfilError[] {
    const sinkey = errores.filter(e => !e.error_key || e.error_key.trim() === '');
    // vaciar tabla errores solo si está el campo error_key vacio, perfil ya es público, para que no salga la siguiente vez
    if (sinkey.length > 0) {
      this.query.query('misdatos', 'VACIARERRORES', null).subscribe((resultado: any) => {
        this.statusService.cargarErroresDesdeBackend();
        //this.toastr.success('Tu perfil ya es público');
        // Enviar email al administrador de perfil público
        
      });
    }
    return sinkey;
  }
}
